import React, { useMemo, useState } from 'react';
import Bowser from 'bowser';
import { useTranslation } from 'react-i18next';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import CloseIcon from '../../../../assets/close.svg';
import { Typography } from 'antd';

export const BrowserWarning: React.FC = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);
  const [disabled, setDisabled] = useState(
    localStorage.getItem('analysis_browser_warning_disabled') === '1',
  );

  const isChrome = useMemo(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);

    return browser.getBrowserName() === 'Chrome';
  }, []);

  const isOpen = useMemo(() => {
    return !isChrome && !dismissed && !disabled;
  }, [dismissed, disabled, isChrome]);

  const onClickDisable = () => {
    localStorage.setItem('analysis_browser_warning_disabled', '1');
    setDisabled(true);
  };

  if (!isOpen) return null;

  return (
    <div className="absolute z-[500] bottom-0 left-0 right-0 h-[50px] bg-[#373948] flex items-center justify-center">
      <div className="relative flex items-center gap-x-[1em]">
        <Typography className="text-white">{t('browser_warning.label')}</Typography>
        <Button
          type={ButtonType.primary}
          onClick={onClickDisable}
          data-cy="dismiss_browser_warning_button"
        >
          {t('browser_warning.button_dismiss')}
        </Button>
        <div
          className="absolute right-[-25px] aspect-square cursor-pointer"
          onClick={() => setDismissed(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setDismissed(true);
            }
          }}
        >
          <img src={CloseIcon} alt={`${t('browser_warning.icon_alt')}`} />
        </div>
      </div>
    </div>
  );
};
